var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FAFAFA","fillRule":"evenodd","d":"M28 9.116v17.768c0 .298-.104.558-.313.781a1.05 1.05 0 0 1-.803.335h-5.09v-7.768h2.59l.402-2.99h-2.991v-1.92c0-.507.089-.864.267-1.072.239-.268.64-.402 1.206-.402h1.607v-2.723a25.15 25.15 0 0 0-2.321-.09c-1.161 0-2.099.343-2.813 1.027-.714.685-1.071 1.667-1.071 2.947v2.232h-2.59v2.991h2.59V28H9.116a1.05 1.05 0 0 1-.803-.335A1.109 1.109 0 0 1 8 26.884V9.116c0-.327.104-.595.313-.803.208-.209.476-.313.803-.313h17.768c.298 0 .558.104.781.313.223.208.335.476.335.803z"}));
}

Facebook.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Facebook;

Facebook.default = Facebook;
